import { ArgumentException } from '../../../exceptions/argument-exception';
import { Currency } from '../../../models/serializable/currency';
import { GenericOrder } from '../../../models/serializable/orders/generic-order';
import { GenericOrderDonationEntry } from '../../../models/serializable/orders/generic-order-entries/generic-order-donation-entry';
import { GenericOrderEntry } from '../../../models/serializable/orders/generic-order-entry';
import { Price } from '../../../models/serializable/price';
import { GenericOrderDiscountBreakdownEntry } from '../discount-breakdown';
import { GenericOrderFeeBreakdownEntry } from '../fee-breakdown';
import { IGenericOrderPaymentHelperAdapter } from './generic-order-payment-helper-adapter';

export class DonationEntryPaymentHelperAdapter extends IGenericOrderPaymentHelperAdapter {
  public readonly orderEntryTypeId: string = GenericOrderDonationEntry.TYPE_ID;

  static verifyType(dm: IGenericOrderPaymentHelperAdapter): boolean {
    return dm instanceof DonationEntryPaymentHelperAdapter;
  }

  static assertType(dm: IGenericOrderPaymentHelperAdapter): dm is DonationEntryPaymentHelperAdapter {
    return dm instanceof DonationEntryPaymentHelperAdapter;
  }

  getCurrency(order: GenericOrder, orderEntry: GenericOrderEntry): Currency | null {
    if(!GenericOrderDonationEntry.assertType(orderEntry)) {
      throw new ArgumentException('order', 'Order entry type is not valid');
    }

    return orderEntry.donation.currency;
  }

  calculateDiscountBreakdown(
      order: GenericOrder,
      orderEntry: GenericOrderEntry,
      _orderEntryIndex: number
  ): GenericOrderDiscountBreakdownEntry[] | null {
    if(!GenericOrderDonationEntry.assertType(orderEntry)) {
      throw new ArgumentException('order', 'Order entry type is not valid');
    }

    return null;
  }

  calculateFeeBreakdown(
      order: GenericOrder,
      orderEntry: GenericOrderEntry,
      _orderEntryIndex: number
  ): GenericOrderFeeBreakdownEntry[] | null {
    if(!GenericOrderDonationEntry.assertType(orderEntry)) {
      throw new ArgumentException('order', 'Order entry type is not valid');
    }

    return null;
  }

  calculateCheckoutPrice(order: GenericOrder, orderEntry: GenericOrderEntry): Price | null {
    if(!GenericOrderDonationEntry.assertType(orderEntry)) {
      throw new ArgumentException('order', 'Order entry type is not valid');
    }

    return orderEntry.donation;
  }

  calculateIncome(order: GenericOrder, orderEntry: GenericOrderEntry): Price | null {
    if(!GenericOrderDonationEntry.assertType(orderEntry)) {
      throw new ArgumentException('order', 'Order entry type is not valid');
    }

    // donations are not considered income
    return Price.zero(orderEntry.donation.currency);
  }

  calculateIncomeWithoutDiscount(order: GenericOrder, orderEntry: GenericOrderEntry): Price | null {
    if(!GenericOrderDonationEntry.assertType(orderEntry)) {
      throw new ArgumentException('order', 'Order entry type is not valid');
    }

    // donations are not considered income
    return Price.zero(orderEntry.donation.currency);
  }

  calculateDiscount(orderEntry: GenericOrderEntry): Price | null {
    if(!GenericOrderDonationEntry.assertType(orderEntry)) {
      throw new ArgumentException('order', 'Order entry type is not valid');
    }

    return null;
  }

  calculateCheckoutPriceForDiscountProvider(orderEntry: GenericOrderEntry): Price | null {
    if(!GenericOrderDonationEntry.assertType(orderEntry)) {
      throw new ArgumentException('order', 'Order entry type is not valid');
    }

    return null;
  }

  canCreateRefund(order: GenericOrder, orderEntry: GenericOrderEntry): boolean | null {
    if(!GenericOrderDonationEntry.assertType(orderEntry)) {
      throw new ArgumentException('order', 'Order entry type is not valid');
    }

    return null;
  }

  calculateMaxSimulatedRefund(order: GenericOrder, orderEntry: GenericOrderEntry): Price | null {
    if(!GenericOrderDonationEntry.assertType(orderEntry)) {
      throw new ArgumentException('order', 'Order entry type is not valid');
    }

    return null; // not refundable
  }
}
